import * as actionTypes from "../actionTypes/actionTypes";
import { getReportListService } from "../services/ReportService";
const getReportListAction = (payload) => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_REPORT_FETCH_STARTED
        })
        window.startLoading();
        getReportListService(payload).then((response) => {
            const data = response.data;
            console.log('report action',data)
            dispatch({
                type: actionTypes.GET_REPORT_FETCH_SUCCESS,
                payload: data
            })
        })
            .catch((error) => {
                dispatch({
                    type: actionTypes.GET_REPORT_FETCH_FAILURE,
                    payload: error
                })
            }).finally(() => {
                window.stopLoading();
            })
    }
}

export {getReportListAction};